export default __webpack_public_path__ + "static/avatar3-b8876cc1e59fc8ee0545e730b1d4956e.png";